import * as types from './types';

const INITIAL_STATE = {
  loading: false,
  kitchenItems: [],
  neededQtyDiff: [],
  fetchKitchenItemListError: null,
  submitted: false,
  submitError: null,
  kitchenPrepSubmitLoading: false,
  fetchingKitchenPrepDetail: false,
  fetchingKitchenPrepDetailError: null,
  selectedKitchenPrepData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_DATA:
      return {
        ...state,
        kitchenItems: action.payload,
      };

    case types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.CREATE_EDIT_NEEDED_PREPARED_DIFF:
      return {
        ...state,
        neededQtyDiff: action.payload,
      };

    case types.CREATE_EDIT_KITCHEN_PREP_WORKSHEET_ERROR:
      return {
        ...state,
        fetchKitchenItemListError: action.payload,
      };

    case types.CLEAR_KITCHEN_ERROR:
      return {
        ...state,
        fetchKitchenItemListError: null,
        fetchingKitchenPrepDetailError: null,
        submitError: null,
        submitted: false,
      };

    case types.KITCHEN_PREP_WORKSHEET_SUBMIT:
      return { ...state, submitted: true };

    case types.KITCHEN_PREP_WORKSHEET_SUBMITTING:
      return { ...state, kitchenPrepSubmitLoading: action.payload };

    case types.KITCHEN_PREP_WORKSHEET_SUBMIT_ERROR:
      return { ...state, submitError: action.payload };

    case types.FETCHING_KITCHEN_PREP_DETAIL:
      return {
        ...state,
        fetchingKitchenPrepDetail: action.payload,
      };

    case types.SELECTED_KITCHEN_PREP_DETAIL:
      return {
        ...state,
        selectedKitchenPrepData: action.payload,
      };

    case types.FETCHING_KITCHEN_PREP_DETAIL_ERROR:
      return { ...state, fetchingKitchenPrepDetailError: action.payload };
    default:
      return {
        ...state,
      };
  }
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/createEditKitchenPrepWorksheet/reducer.js